import { useEffect, type RefObject } from "react";

/**
 * Closes an open tooltip when a scroll container of its trigger scrolls. The
 * popup is portalled, so Base UI cannot tell when a scroll container (a
 * Picker list, a table body) clips the trigger; without this the tooltip
 * rides along past the container's edge.
 */
export const useCloseOnContainerScroll = ({
    triggerRef,
    isOpen,
    onClose,
}: {
    triggerRef: RefObject<HTMLElement | null>;
    isOpen: boolean;
    onClose: () => void;
}) => {
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }
        const handleScroll = (event: Event) => {
            const trigger = triggerRef.current;
            if (
                trigger !== null &&
                event.target instanceof Element &&
                event.target.contains(trigger)
            ) {
                onClose();
            }
        };
        document.addEventListener("scroll", handleScroll, {
            capture: true,
            passive: true,
        });
        return () =>
            document.removeEventListener("scroll", handleScroll, {
                capture: true,
            });
    }, [isOpen, onClose, triggerRef]);
};
